/**
 * Query param Cue hosts listen for on landing. Same contract as hire-go
 * and recruiter-ui. Value is the user message sent after the panel opens.
 */
export const PRESET_CUE_MESSAGE_PARAM = 'preset_cue_message';

/** Message the freemium multi-opening dialog puts in that query param. */
export const FREEMIUM_MULTI_OPENING_CUE_MESSAGE =
  'Hey Cue!\nCan you help me provide a sourcing plan for the selected openings based on its current performance?';

/** Message the All Campaigns Post job popover sends when the recruiter chooses Cue. */
export const CAMPAIGNS_POST_JOB_CUE_MESSAGE =
  'Hey Cue!\nI want to start sourcing for my openings. Recommend which opening I need to start sourcing based on their current performance, and provide a recommended channel and budget mix';

/**
 * Staging key for openings selected in the job-posting wizard.
 *
 * Cue is hidden on `/post-job`, so ephemeral context cannot be pushed from
 * the wizard. Job-posting localStorage is cleared on leave, so openings
 * cannot ride that store. sessionStorage survives the in-app navigate.
 * `consumeCueSelectedOpenings` is one-shot so a refresh does not re-push.
 */
export const CUE_SELECTED_OPENINGS_STORAGE_KEY = 'source.cue.selected-openings';

export type CueSelectedOpening = {
  id: string;
  name: string;
};

export function writeCueSelectedOpenings(openings: CueSelectedOpening[]): void {
  sessionStorage.setItem(
    CUE_SELECTED_OPENINGS_STORAGE_KEY,
    JSON.stringify(openings),
  );
}

/**
 * Reads and clears the openings staged for Cue. Returns null when nothing
 * was stored or the payload is not a list of id/name pairs.
 */
export function consumeCueSelectedOpenings(): CueSelectedOpening[] | null {
  const raw = sessionStorage.getItem(CUE_SELECTED_OPENINGS_STORAGE_KEY);
  if (!raw) return null;

  sessionStorage.removeItem(CUE_SELECTED_OPENINGS_STORAGE_KEY);

  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;

    const openings: CueSelectedOpening[] = [];
    for (const item of parsed) {
      if (
        item &&
        typeof item === 'object' &&
        typeof (item as CueSelectedOpening).id === 'string' &&
        typeof (item as CueSelectedOpening).name === 'string'
      ) {
        openings.push({
          id: (item as CueSelectedOpening).id,
          name: (item as CueSelectedOpening).name,
        });
      }
    }
    return openings.length > 0 ? openings : null;
  } catch {
    return null;
  }
}
